﻿import config from "../config"
const baseUrl = config.base_url + "farm/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    list: {
        url:  baseUrl + "list",
        type: "post",
    },
    add: {
        url:  baseUrl + "insert",
        type: "post",
    },
    edit: {
        url:  baseUrl + "update",
        type: "post",
    },
    inviteCode: {
        url:  baseUrl + "inviteCode/{gardenId}",
        type: "get",
    },

}

